/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from "react";
import { Tabs, message, Spin } from "antd";
import API from "../../api";
import urls from "../../api/urls";
import { useLocation, useParams } from "react-router-dom";
import Heading from "../../components/Heading";
import CashRateCard from "./CashRateCard";

const { GET_RATE_CARD_QUOTATION, GET_RATECARD_BY_USER, GET_RATECARD_BY_NAME } =
  urls;

const RateCards = () => {
  const currentEnv = process.env.REACT_APP_ENV;
  const history = useLocation();
  const [loader, setLoader] = useState(false);
  const [cashData, setCashData] = useState({});
  const [accountData, setAccountData] = useState({});
  const [activeKey, setActiveKey] = useState(1);
  const [rateCardsData, setRateCardsData] = useState([]);
  const [fetchRate, setFetchRate] = useState(false);

  useEffect(() => {
    //if (quotationId) {
    getQuotationDetail();
    //console.log(history);

    //}
  }, [history?.state, fetchRate]);

  const changeTab = (key) => {
    setActiveKey(key);
  };

  const getQuotationDetail = async () => {
    try {
      setLoader(true);
      const companyId =
        JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;
      const cashQuotationName =
        JSON.parse(localStorage.getItem("selectedCompany"))
          ?.cashQuotationName || null;
      let res;
      // currentEnv === "qa"
      //   ? await API.Api(
      //       GET_RATE_CARD_QUOTATION +
      //         cashQuotationName +
      //         "?includeOld=" +
      //         false
      //     ).get()
      //   :
      let data = [];
      if (history?.state?.rateCard) {
        res = await API.Api(
          GET_RATECARD_BY_NAME + "?name=" + history?.state?.rateCard
        ).get();
        data = res?.response?.data?.items || [];
      } else {
        res = await API.Api(GET_RATECARD_BY_USER + companyId).get();
        data = res?.response?.data || [];
      }

      setRateCardsData(data);
      setLoader(false);
    } catch (error) {
      message.error("Failed to fetch quotation details.");
    } finally {
      setLoader(false);
    }
  };

  const tabItems = rateCardsData?.map((item, index) => ({
    label: item.type, // Tab Title
    key: index + 1, // Unique Key
    children: (
      <CashRateCard
        data={item}
        edit={history?.state?.actionEdit}
        getInitialData={() => setFetchRate(!fetchRate)}
        customerId={history?.state?.customerId}
        rateCardType={history?.state?.rateCardType}
      />
    ), // Tab Content
  }));

  return (
    <div className="p-1">
      <Spin spinning={loader}>
        {history?.state ? (
          <Heading
            title="Assigned Rate Cards"
            navigateTo={history?.state?.url}
            id={history?.state?.tabKey}
          />
        ) : (
          <Heading title="Assigned Rate Cards" />
        )}

        {rateCardsData?.length > 0 ? (
          <Tabs
            type="card"
            items={tabItems}
            activeKey={activeKey}
            onChange={changeTab}
            className="rate-card-tab"
          />
        ) : (
          <div className="no-data-prresnt">
            No rate card has been configured, please contact to HO team.
          </div>
        )}
      </Spin>
    </div>
  );
};

export default RateCards;
